/* ============================================================
   MP VARIANT CARDS — Selettore formato card con prezzo inline.
   - Header "SCEGLI IL FORMATO" a sinistra (verticalmente centrato)
   - Card 50ML/100ML a destra con prezzo + sottotitolo + badge
   - Observer su <body> (sopravvive ai replace di Broadcast)
   - Sorgente prezzi: window.MP_VARIANTS (iniettato in head.liquid)
   ============================================================ */
(function () {
  'use strict';

  var VARIANT_CONFIG = {
    '50':  { sub: 'Formato Standard',  badge: null },
    '100': { sub: 'Formato Risparmio', badge: 'MIGLIOR PREZZO' }
  };

  var building = false;
  var pendingRebuild = false;

  function getConfig(title) {
    var t = (title || '').toLowerCase();
    if (t.indexOf('100') !== -1) return VARIANT_CONFIG['100'];
    if (t.indexOf('50')  !== -1) return VARIANT_CONFIG['50'];
    return { sub: '', badge: null };
  }

  function formatPrice(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function needsRebuild() {
    var container = document.querySelector('[data-variant-buttons]');
    if (!container) return false;
    return !container.querySelector('.mp-vc__card');
  }

  function buildCards() {
    var variants = window.MP_VARIANTS;
    if (!variants || !variants.length) return;

    var container = document.querySelector('[data-variant-buttons]');
    if (!container) return;
    if (container.querySelector('.mp-vc__card')) return; // already built

    building = true;

    // Wrap fieldset + nascondi legend
    var fieldset = container.closest('.radio__fieldset') ||
                   container.closest('fieldset') ||
                   container.closest('.product-form__input');
    if (fieldset) {
      fieldset.classList.add('mp-vc__wrap');
      var legend = fieldset.querySelector('legend, .radio__legend');
      if (legend) legend.style.display = 'none';
    }

    // Inserisci header PRIMA di [data-variant-buttons]
    var parent = container.parentNode;
    var existingHeader = parent.querySelector(':scope > .mp-vc__header');
    if (existingHeader) existingHeader.remove();
    var header = document.createElement('div');
    header.className = 'mp-vc__header';
    header.innerHTML = 'SCEGLI IL FORMATO';
    parent.insertBefore(header, container);

    container.setAttribute('data-mp-cards', '1');

    // Riscrivi ogni label come card
    var radioButtons = container.querySelectorAll('.radio__button');
    radioButtons.forEach(function (wrap, i) {
      var input = wrap.querySelector('input[type="radio"]');
      var label = wrap.querySelector('label');
      if (!input || !label) return;

      var optionValue = input.value;

      var variant = null;
      for (var j = 0; j < variants.length; j++) {
        var v = variants[j];
        if (v.option1 === optionValue || v.option2 === optionValue || v.title === optionValue) {
          variant = v;
          break;
        }
      }
      if (!variant) variant = variants[i] || variants[0];

      var cfg = getConfig(optionValue);

      label.className = 'mp-vc__card';
      label.innerHTML = '';

      var checkEl = document.createElement('span');
      checkEl.className = 'mp-vc__check';
      checkEl.setAttribute('aria-hidden', 'true');
      checkEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><polyline points="4 12.5 10 18.5 20.5 6"/></svg>';

      var left = document.createElement('div');
      left.className = 'mp-vc__card-left';

      var titleEl = document.createElement('div');
      titleEl.className = 'mp-vc__card-title';
      titleEl.textContent = optionValue.toUpperCase();
      left.appendChild(titleEl);

      var subEl = document.createElement('div');
      subEl.className = 'mp-vc__card-sub';
      subEl.textContent = cfg.sub;
      left.appendChild(subEl);

      var dividerEl = document.createElement('div');
      dividerEl.className = 'mp-vc__card-divider';

      var right = document.createElement('div');
      right.className = 'mp-vc__card-right';

      var priceEl = document.createElement('div');
      priceEl.className = 'mp-vc__card-price';
      priceEl.textContent = variant ? formatPrice(variant.price) : '';
      right.appendChild(priceEl);

      label.appendChild(checkEl);
      label.appendChild(left);
      label.appendChild(dividerEl);
      label.appendChild(right);

      if (cfg.badge) {
        var existingBadge = wrap.querySelector('.mp-vc__badge');
        if (existingBadge) existingBadge.remove();
        var badge = document.createElement('div');
        badge.className = 'mp-vc__badge';
        badge.textContent = cfg.badge;
        wrap.appendChild(badge);
      }
    });

    // Release lock dopo che le mutazioni del nostro DOM sono state ingoiate
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { building = false; });
    });
  }

  function maybeRebuild() {
    if (building) return;
    if (pendingRebuild) return;
    if (!needsRebuild()) return;
    pendingRebuild = true;
    // Microtask: rebuild appena finisce il batch di mutazioni di Broadcast
    requestAnimationFrame(function () {
      pendingRebuild = false;
      if (needsRebuild()) buildCards();
    });
  }

  // Observer su body: sopravvive a qualunque replace di Broadcast
  function attachObserver() {
    if (document.body.getAttribute('data-mp-vc-observed')) return;
    document.body.setAttribute('data-mp-vc-observed', '1');
    var observer = new MutationObserver(maybeRebuild);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Backup: change delegato — cattura selezione variante
  function attachChangeListener() {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) {
        setTimeout(maybeRebuild, 60);
        setTimeout(maybeRebuild, 200);
        setTimeout(maybeRebuild, 500);
      }
    }, true);
  }

  function init() {
    buildCards();
    attachObserver();
    attachChangeListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', maybeRebuild);
})();
